import { integrationStatuses } from '@/configuration/pages/ConfigurationPage/IntegrationsConfigurations/constants'

import { shopifyThemeEditorPath } from './constants'

export const isSeelInstalling = status => status === integrationStatuses.pending

export const isSeelFailed = status => status === integrationStatuses.failed

export const isSeelInstallationUnreachable = integration => {
  return isSeelInstalling(integration.status) && !integration.websocket_url
}

export const isSeelActivated = status => [integrationStatuses.installed, integrationStatuses.disabled].includes(status)

export const getSeelDashboardUrl = integration => integration?.information?.seel_dashboard_url?.value

export const getShopifyThemeEditorUrl = domain => {
  return `https://${domain}${shopifyThemeEditorPath}`
}

export const findIntegrationByType = (integrations, type) => integrations.find(integration => integration.type === type)
